"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewCartEvent = void 0;
const abstract_sales_event_1 = require("./abstract-sales.event");
class ViewCartEvent extends abstract_sales_event_1.AbstractSalesEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'view_cart';
    }
    getData() {
        return {
            currency: this.config.currency,
            value: this.config.value,
            totalQuantity: this.config.totalQuantity,
            items: Array.isArray(this.config.items) ? this.config.items.map(item => (Object.assign({}, item))) : [],
        };
    }
}
exports.ViewCartEvent = ViewCartEvent;
//# sourceMappingURL=view-cart.event.js.map